import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BusinessUnitIdService {
    private businessUnitIdSubject = new BehaviorSubject<number | null>(null);

    public setBusinessUnitId(id: number | null) {
        this.businessUnitIdSubject.next(id);
    }

    public getBusinessUnitId(): number | null {
        return this.businessUnitIdSubject.getValue();
    }
}
